let body = document.querySelector("body"),
  productCheck = body.classList.contains("template-product"),
  collectionCheck = body.classList.contains("template-collection"),
  directoryLinks = document.querySelectorAll(".custom--directory-container"),
  careModal = document.getElementById("customer-care"),
  careLink = document.querySelector(".care-title"),
  filterCheck = document.querySelector("#CollectionFiltersForm") !== null,
  mobileCheck = window.innerWidth < 900,
  footerCheck = document.querySelector("footer") !== null;

const logs = true;

// if (careModal !== null) {
//   if (mobileCheck) {
//     careLink.textContent = "Help";
//   }
// }

// window.addEventListener("resize", function () {
//   if (careModal !== null) {
//     if (mobileCheck) {
//       careLink.textContent = "Help";
//     }
//   }
// });


function setHeaderMegaHeight() {
  // Set the height of the mega menu based on the header height
  if (document.querySelector("header.main-header") !== null) {    
  
    let headerHeight =
      document.querySelector("header.main-header").clientHeight;
    document.documentElement.style.setProperty( "--header-mega-height","".concat(headerHeight,"px"));

    if (logs) {
      console.log("Header height set to: " + headerHeight + "px");
    }
  } 
}
   




// console.log("infinite.js");

// Updates the scroll path and filter status for the container
function updateScrollPath(container) {
  if (!container) return; // Prevent errors if container is missing
  if (logs) {
    console.log("updateScrollPath", container);
  }
  const filterUrl = window.location.href;
  const shopUrl = container.dataset.root;
  const afterDomain = filterUrl.split(".com");
  const path = afterDomain[1];

  // Check if URL has active filter
  if (filterUrl.indexOf("?") === -1) {
    if (logs) console.log("No active filter found", filterUrl);
    container.dataset.filter = "false";
    return;
  } else {
    container.dataset.path = path;
    container.dataset.filter = "true";
    if (logs) console.log("Active filter found", path);
  }
}

// Main Infinite Scroll function

let infiniteScrollSimple = true

function initInfiniteScrollSimple() {

  if (!infiniteScrollSimple) {
    return;
  }

  const productGrid = document.querySelector(
    "#CollectionProductGrid .collection-list",
  );


  console.log("initInfiniteScroll simple, replace history called");
  
  if (productGrid) {
    const parent = productGrid.parentNode
    const pagination = parent.querySelector(".pagination-container");
  
    if (productGrid && pagination && parent.getAttribute("data-scroll") === "true") {
      new InfiniteScroll(productGrid, {
        path: 'a.pagination__step.next',
        append: '.collection-list > li.collection-list__item',
        hideNav: '.pagination-container',
        status: '.page-load-status',
        history: 'replace',
        onInit: function () {
          this.on("load", function (event, body, path, response) {
            if (logs) {
              console.log("Infinite Scroll load");
              console.log("Next path:", path); 
            } 
            infiniteScrollInitialized = true;
          })
        },
        onError: function () {
          console.log("Infinite Scroll error");
          document.querySelector(".pagination-container").style.display = "flex";
        }
      
      });
      
    }
  }
}


function infScroll(container) {
  if (infiniteScrollSimple) {
    return;
  }
  if (!container) {
    console.warn("infScroll: container is null or undefined");
    return;
  }
  const parent = container.parentNode;
  if (!parent) {
    console.warn("infScroll: parent is null or undefined");
    return;
  }
  // Set up scroll path and filter
  updateScrollPath(parent);

  // Get pagination and control elements
  const pagination = parent.querySelector(".pagination");
  const viewMore = document.querySelector(".view-more");
  const btt = document.querySelector(".btt-anchor");
  const filterCheck = parent.dataset.filter === "true";
  const partsCount = pagination
    ? parseInt(pagination.dataset.partsCount, 10)
    : 0;
  const currentLimit = parent.dataset.limit
    ? parseInt(parent.dataset.limit, 10)
    : 0;

  let appendInstance = 1, // Track how many times append has run
    currentPage = 2, // Start at 2 since page 1 is already loaded
    append = ".collection-list > li.collection-list__item", 
    path = "a.pagination__step.next";

  if (logs) {
    console.log("infiniteScroll - pagination partsCount = ", partsCount);
    console.log("infiniteScroll - currentLimit = ", currentLimit);
    console.log("infiniteScroll - append = ", append);
  }

  // If no pagination, disable infinite scroll
  if (!pagination) {
    if (logs) console.log("no pagination, no infinite scroll");
    if (btt) {
      btt.classList.add("visually-hidden");
      btt.classList.remove("btt-active"); 
    }
    return;
  }

  // Check if infinite scroll is enabled
  const infScrollActive = parent.getAttribute("data-scroll");
  if (infScrollActive !== "true") {
    if (logs) console.log("infinite scroll disabled in settings");
    return;
  }

  if (logs) console.log("infinite scroll active");
  const viewMoreText = viewMore.querySelector(".view-more__button");
  viewMore.classList.remove("visually-hidden");

  // Initialize InfiniteScroll
  infiniteScroll = new InfiniteScroll(container, {
    hideNav: ".pagination", // Hide default pagination
    // Path function returns the next page URL
    path: function () {
      if (currentPage <= partsCount) {
        return filterCheck
          ? parent.dataset.path + "&page=" + currentPage
          : parent.dataset.path + "?page=" + currentPage;
      } else {
        return null; // Stop when max page reached
      }
    },
    // Only append items for the current page
    append: append,
    history: 'replace',
    historyTitle: true,
    onInit: function () {
      // Event: InfiniteScroll load
      this.on("load", function (event, body, path, response) {
        if (logs) {
          console.log("Infinite Scroll load");
          console.log("Infinite Scroll collection limit = " + currentLimit);
        }
      });
      // Event: Request sent
      this.on("request", function (path) {
        viewMoreText.textContent = "Loading…";
      });
      // Event: Items appended to grid
      this.on("append", function (body, path, items, response) {
        // Assign data-page to each item for tracking
        items.forEach((item) => {
          item.setAttribute("data-append", currentPage);
        });
        if (logs) {
          console.log("Infinite Scroll append - instance:", appendInstance);
          console.log("currentPage = " + currentPage);
          console.log("items length = " + items.length);
          if (items.length > 0) {
            console.log(
              "Page:" + currentPage + " First item handle:",
              items[0].dataset.handle,
              " - Page:",
              items[0].dataset.page,
              " - Index:",
              items[0].dataset.index,
            );
            console.log(
              "Page:" + currentPage + " Last item handle:",
              items[items.length - 1].dataset.handle,
              " - Page:",
              items[items.length - 1].dataset.page,
              " - Index:",
              items[items.length - 1].dataset.index,
            );
          }
        }
        currentPage++; // Increment page for next request
        appendInstance++;

        // append = `li.collection-list__item[data-page="${currentPage}"]`;
        // Show back-to-top anchor
        if (btt) {
          btt.classList.remove("visually-hidden");
          btt.classList.add("btt-active");
        }
        if (logs) {
          console.log("Infinite Scroll append body HTML - ", body);
          console.log("Infinite Scroll append path - " + path);
          console.log("Infinite Scroll collection limit = " + currentLimit);
          console.log("Infinite Scroll append length - " + items.length);
          console.log("Infinite Scroll append response - " + response.status);
          console.log("Infinite Scroll next page - " + currentPage);
          console.log("Infinite Scroll append - " + append);
        }
      });
      // Event: Error during request
      this.on("error", function (error, path, response) {
        if (logs) {
          console.log("Infinite Scroll error");
          console.log("Infinite Scroll error path - " + path);
        }
      });
      // Event: Last page reached
      this.on("last", function () {
        if (logs) {
          console.log("Infinite Scroll last, path= null");
        }
      });
    },
  });
}

// Entry point for infinite scroll
function runScroll() {
  let latestProductGrid = document.querySelector(
    "#CollectionProductGrid .collection-list",
  );
  infScroll(latestProductGrid);
  initInfiniteScrollSimple();
}

class CustomDirectory {
  constructor(target) {
    target.addEventListener("click", this.onDirectoryClick.bind(this));
  }

  onDirectoryClick(event) {
    const parentCheck = event.target.classList.contains("parent-link");

    if (!parentCheck) {
      console.log("normal link");
    } else {
      console.log("parent link");
      event.preventDefault();

      let parent = event.target.parentNode,
        container = parent.parentNode,
        child = container.querySelector(".custom--directory-child-wrap"),
        openClass = child.classList.contains("directory-open");

      const children = document.querySelectorAll(
        ".custom--directory-child-wrap",
      );

      if (window.innerWidth > 1024) {
        if (!openClass) {
          children.forEach((child) => {
            child.classList.add("directory-open");
          });
        } else {
          children.forEach((child) => {
            child.classList.remove("directory-open");
          });
        }
      } else {
        if (!openClass) {
          child.style.display = "block";
          child.classList.add("directory-open");
        } else {
          child.classList.remove("directory-open");
          child.style.display = "none";
        }
      }
    }
  }
}

const slider = document.querySelector(".custom__slider");

function desktopSlider(slider) {
  if (window.innerWidth > 1024) {
    new Flickity(slider, {
      // options
      cellAlign: "left",
      contain: true,
      cellSelector: ".custom__slide",
      setGallerySize: false,
      arrowShape:
        "M35.2836 13L0 49.9095L35.2836 86.819L39.3694 82.5436L11.2003 53.0708H100V46.7482L11.1982 46.7461L39.3694 17.2754L35.2836 13Z",
    });
  }
}

class CustomerCare {
  constructor(target) {
    target.addEventListener("click", this.onCareClick.bind(this));
  }

  onCareClick(event) {
    let careActive = document
        .querySelector("html")
        .classList.contains("care-active"),
      list = document.querySelector(".care-list"),
      careLink = document.querySelector("a.care-title");

    if (mobileCheck) {
      var span = careLink.querySelector("span.title.mobile");
      var title = span.dataset.title;
    } else {
      var span = careLink.querySelector("span.title.desktop");
      var title = span.dataset.title;
    }

    // event.target.classList.toggle("care-active");
    document.querySelector("html").classList.toggle("care-active");

    if (!careActive) {
      console.log("show " + span + " " + title);
      list.style.display = "flex";
      span.textContent = "×";
    } else {
      console.log("hide " + span + " " + title);
      list.style.display = "none";
      span.textContent = title;
    }
  }
}

window.addEventListener("click", function (e) {
  var customerCare = document.getElementById("customer-care");

  if (customerCare === null) {
    return;
  }
  if (document.getElementById("customer-care").contains(e.target)) {
  } else {
    if (mobileCheck) {
      var title = careLink.dataset.mobileTitle;
      var span = careLink.querySelector("span.title.mobile");
    } else {
      var title = careLink.dataset.title;
      var span = careLink.querySelector("span.title.desktop");
    }

    document.querySelector("html").classList.remove("care-active");
    careLink.classList.remove("care-active");

    document.querySelector(".care-list").style.display = "none";
    span.textContent = title;
  }
});

function gorgiasReveal(link) {
  let htmlEl = document.querySelector("html");

  link.addEventListener("click", function (e) {
    htmlEl.classList.toggle("gorgias-active");

    let classCheck = htmlEl.classList.contains("gorgias-active");

    if (classCheck) {
      link.textContent = "Close Chat";
    } else {
      link.textContent = link.dataset.text;
    }
  });
}

class SortClick {
  constructor(target) {
    target.addEventListener("click", this.onSortClick.bind(this));
  }

  onSortClick(e) {
    let form = e.target.closest("form");
    // console.log('click ' + form)
    form.classList.toggle("sort-open");
  }
}

// if (filterCheck) {

//   new SortClick(document.querySelector('.sort-wrap button'))
// }

let chatLink = document.querySelector(".js-chat-link");

// Weird empty footer link fix :(

if (footerCheck) {
  // console.log('footer check')
  if (!mobileCheck) {
    // console.log('mobile check')
    let footer = document.querySelector("footer"),
      footerWrapChildren = footer.querySelectorAll(".footer-wrap--new a");

    footerWrapChildren.forEach((child) => {
      child.innerHTML.trim().length == 0
        ? child.remove()
        : console.log("removed empty footer link");
    });
  }
}

// Click to resume video

var mq = window.matchMedia("(max-width: 1024px)");
var mediaList = document.querySelector(".splide__list");

function videoObserver() {
  let slide = document.querySelector(".splide__slide"),
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            let video = entry.target.querySelector("video");
            if (video === null) {
              return;
            }
            video.play();
            // console.log('video play')
          } else {
            let video = entry.target.querySelector("video");
            if (video === null) {
              return;
            }
            video.pause();
            // console.log('video paused')
          }
        });
      },
      {
        threshold: [0, 0.1, 1],
      },
    );
  observer.observe(slide);
}

function onlyVariantImageLoad() {
  var variantImages = document.querySelectorAll("[data-variant-image]");
  var currentMedia = document.querySelector(".section--main-product").dataset
    .currentVariantMedia;
  let mobile = window.innerWidth < 1024;

  // console.log('hide images')

  variantImages.forEach((image) => {
    if (mobile) {
      if (image.dataset.mediaId != currentMedia) {
        image.classList.add("hidden-variant");
        image.closest("li").classList.remove("is-active");
        image.closest("li").classList.remove("splide__slide");
      }
    } else {
      if (image.dataset.mediaId != currentMedia) {
        image.closest("li").classList.add("visually-hidden");
        image.closest("li").classList.remove("is-visible");
        image.closest("li").classList.remove("is-active");
        image.closest("li").classList.remove("splide__slide");
      }
    }
  });

  // console.log('images hidden')
}

if (productCheck) {
  let onlyCheck =
    document.querySelector(".section--main-product").dataset
      .variantImageBehaviour == "only";
  if (onlyCheck) {
    console.log("only variant image load");
    onlyVariantImageLoad();
  }
} else {
  if (logs) {
    console.log("all images load");
  }
}

// Megamenu

function megaMenu() {
  if (window.innerWidth > 1024) {
    let megaMenuLinks = document.querySelectorAll(
        ".header-main__nav__item--link--mega",
      ),
      regularLinks = document.querySelectorAll(".header-main__nav__item--link"),
      bannerSpacer = document.querySelector(".banner-sticky"),
      bannerSpacers = document.querySelectorAll(".banner-sticky"),
      annBar = document.querySelector("#shopify-section-announcement-bar");

    if (bannerSpacer !== null && annBar !== null) {
      if (logs) {
        console.log("banner spacer exists");
      }
      let scrollTimeout;

      window.addEventListener("scroll", () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const scrollY = window.scrollY;
          const annBarHeight = annBar.offsetHeight;
           
          bannerSpacers.forEach((spacer) => {
            if (scrollY > annBarHeight) {
              // Scroll beyond annBar height - set banner spacer to 0
              spacer.style.height = "0px";
            } else {
              // Scroll within annBar height - restore banner spacer height
              spacer.style.height = `${annBarHeight}px`;
            }
          });
        }, 16); // Use 16ms for smoother animation (60fps)
      });
    }

  

    megaMenuLinks.forEach((link) => {
      link.addEventListener("click", function (event) {
        event.preventDefault();
      });

      link.addEventListener("mouseover", function (event) {
        // console.log("mouseover");

        let target = link.getAttribute("data-id"),
          targetEl = document.getElementById(target);

        if (targetEl != null) {
          let openMenus = document.querySelectorAll(".megamenu--active");
          openMenus.forEach((menu) => {
            menu.classList.remove("megamenu--active");
            menu.setAttribute("aria-hidden", true);
            menu.querySelector("a").setAttribute("aria-expanded", false);
          });
          targetEl.classList.add("megamenu--active");
          targetEl.setAttribute("aria-hidden", false);
          link.setAttribute("aria-expanded", true);
        }

        targetEl.addEventListener("mouseleave", function (event) {
          targetEl.classList.remove("megamenu--active");
          targetEl.setAttribute("aria-hidden", true);
          link.setAttribute("aria-expanded", false);
        });
      });
    });

    regularLinks.forEach((link) => {
      link.addEventListener("mouseover", function (event) {
        // console.log("mouseover regular link");
        let openMenus = document.querySelectorAll(".megamenu--active");
        openMenus.forEach((menu) => {
          menu.classList.remove("megamenu--active");
          menu.setAttribute("aria-hidden", true);
          menu.querySelector("a").setAttribute("aria-expanded", false);
        });
      });
    });

    if (Shopify.designMode) {
      console.log("Shopify design mode");

      function showMenu(event) {
        console.log(event.detail.sectionId);

        let target = event.detail.sectionId,
          targetEl = document.querySelector("#shopify-section-" + target);

        if (targetEl) {
          const targetMenu = targetEl.querySelector("section.megamenu");
          if (targetMenu) {
            targetMenu.classList.add("megamenu--active");
          } else {
            console.warn("No <section> found inside target element:", targetEl);
          }
        } else {
          console.warn("Target element not found for ID:", target);
        }
      }

      function hideMenu(event) {
        console.log(event.detail.sectionId);
        let target = event.detail.sectionId,
          targetEl = document.querySelector("#shopify-section-" + target);

        if (targetEl) {
          const targetMenu = targetEl.querySelector("section.megamenu");
          if (targetMenu) {
            targetMenu.classList.remove("megamenu--active");
          } else {
            console.warn("No <section> found inside target element:", targetEl);
          }
        } else {
          console.warn("Target element not found for ID:", target);
        }
      }

      document.addEventListener("shopify:section:select", function (event) {
        showMenu(event);
      });

      document.addEventListener("shopify:section:deselect", function (event) {
        hideMenu(event);
      });
    }
  }
}

directoryLinks.forEach((link) => {
  new CustomDirectory(link);
});
if (careLink !== null) {
  new CustomerCare(careLink);
}
setHeaderMegaHeight();

runScripts = function () {
  megaMenu();

  if (productCheck && mq.matches) {
    videoObserver();
  }

  if (collectionCheck) {
    runScroll();
  }
  if (chatLink !== null) {
    gorgiasReveal(chatLink);
  }
  if (
    productCheck &&
    document.querySelector(".section--main-product").dataset.slider === "true"
  ) {
    desktopSlider(slider);
  }
}; 

runScripts();

window.addEventListener("resize", function () {
  runScripts();
  setHeaderMegaHeight()
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (e) {
    let id = e.detail.sectionId;
    runScroll();
  });
  document.addEventListener("shopify:section:reorder", function (e) {
    let id = e.detail.sectionId;
    runScroll();
  });
  document.addEventListener("shopify:section:unload", function (e) {
    let id = e.detail.sectionId;
    runScroll();
  });

  document.addEventListener("shopify:section:load", function (e) {
    let id = e.detail.sectionId;

    desktopSlider(slider);
  });
  document.addEventListener("shopify:section:reorder", function (e) {
    let id = e.detail.sectionId;

    desktopSlider(slider);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    let id = e.detail.sectionId;
    desktopSlider(slider);
  });
}
